import Api from '../api';

const resource = '/config';

export default {
  get(code: string) {
    return Api.post(`${resource}`, {
      code,
    });
  },
};
